import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"


import { PropType } from 'vue';
import { Action, Button } from '~components/TableComponent/types';

const __default__ = { name: 'CustomDropdownButton' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String as PropType<string>,
  },
  buttons: {
    type: Array as PropType<Button[]>,
  },
  disable: {
    type: Boolean as PropType<boolean>,
  },
},
  emits: ['action'],
  setup(__props, { emit }) {






const onAction = (button: Button) => {
  if (button.disable) {
    return;
  }
  emit('action', button.action);
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    color: "accent",
    style: {"height":"36px"},
    label: __props.label,
    disable: __props.disable
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: index,
              clickable: !button.disable
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  class: _normalizeClass(['custom-item-section', { 'custom-item-section_disable': button.disable }]),
                  disable: button.disable,
                  onClick: ($event: any) => (onAction(button))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: button.icon,
                      size: "sm"
                    }, null, 8, ["name"]),
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(button.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "disable", "onClick"])
              ]),
              _: 2
            }, 1032, ["clickable"])), [
              [_directive_close_popup]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label", "disable"]))
}
}

})